var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#F5F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.092 17.404h17.824M24.443 21.31h.01M20.005 21.31h.01M15.558 21.31h.01M24.443 25.196h.01M20.005 25.196h.01M15.558 25.196h.01M24.043 10v3.29M15.965 10v3.29",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M24.238 11.58h-8.467c-2.937 0-4.771 1.635-4.771 4.642v9.05C11 28.326 12.834 30 15.771 30h8.458C27.175 30 29 28.355 29 25.348v-9.126c.01-3.007-1.816-4.643-4.762-4.643z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.fbcaa73161b2c0f6a3513a6d810b2ea6.svg";
export { ForwardRef as ReactComponent };